module.exports = [{
      plugin: require('../node_modules/gatsby-plugin-manifest/gatsby-browser.js'),
      options: {"plugins":[],"name":"gracescale","short_name":"gracescale","start_url":"/","background_color":"#494A4A","theme_color":"#494A4A","display":"minimal-ui","icon":"src/images/gs.png","cache_busting_mode":"query","include_favicon":true,"legacy":true,"theme_color_in_head":true,"cacheDigest":"6914b2375a8ee85a5c0b35c2d06f74af"},
    },{
      plugin: require('../gatsby-browser.js'),
      options: {"plugins":[]},
    }]
